// @TODO <HEALTH2019>
App.controller('HealthCtrl', ['$rootScope', '$scope', '$sce', '$state', '$http', function ($rootScope, $scope, $sce, $state, $http) {
    if (!$rootScope.CONFIGURATOR.isInsuranceEnabled) {
        var redirectRouteName = 'root.dashboard';
        if ($rootScope.CONFIGURATOR.isHealthInsuranceEnabled) {
            redirectRouteName = 'root.healthInsuranceInfo.start';
        }

        $state.go(redirectRouteName);
    }
}]);
// @TODO </HEALTH2019>
